import { render, staticRenderFns } from "./ExternalLoginWelcomeDialog.vue?vue&type=template&id=c83fd684&scoped=true"
import script from "./ExternalLoginWelcomeDialog.vue?vue&type=script&lang=ts"
export * from "./ExternalLoginWelcomeDialog.vue?vue&type=script&lang=ts"
import style0 from "./ExternalLoginWelcomeDialog.vue?vue&type=style&index=0&id=c83fd684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83fd684",
  null
  
)

export default component.exports